<ng-content select="[left-icon]"></ng-content>
<mat-form-field
    subscriptSizing="dynamic"
    [class]="selectedOptions.length ? 'has-selection' : ''"
    [attr.data-uiid]="dataUiid"
    (click)="onCustomClick($event)"
>
    @if (ngControl?.control) {
        <mat-chip-grid
            #chipGrid
            [formControl]="$any(ngControl!.control)"
            [errorStateMatcher]="errorMatcher"
            [style.display]="selectedOptions.length ? 'flex' : 'none'"
        >
            @for (option of selectedOptions; track option) {
                <mat-chip-row
                    [class]="type"
                    [class.archived]="option.isArchived || (useVisibility && !option.isVisible)"
                    [value]="option.id"
                    [attr.data-uiid]="dataUiid + '-' + option.id"
                    (removed)="remove(option)"
                >
                    {{ option.name }}
                    <button matChipRemove [attr.aria-label]="'remove ' + option.name">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        <input
            [placeholder]="placeholder"
            #searchInput
            [formControl]="formControl"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [attr.data-uiid]="dataUiid + '-input'"
            [matAutocompleteDisabled]="disabled"
            (focusout)="clearInput()"
        />
    } @else {
        <mat-chip-grid
            #chipGrid
            [disabled]="disabled"
            [style.display]="selectedOptions.length ? 'flex' : 'none'"
        >
            @for (option of selectedOptions; track option) {
                <mat-chip-row
                    [class]="type"
                    [class.archived]="option.isArchived || (useVisibility && !option.isVisible)"
                    [value]="option.id"
                    [attr.data-uiid]="dataUiid + '-' + option.id"
                    (removed)="remove(option)"
                >
                    {{ option.name }}
                    <button matChipRemove [attr.aria-label]="'remove ' + option.name">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-chip-row>
            }
        </mat-chip-grid>
        <input
            [placeholder]="placeholder"
            #searchInput
            [formControl]="formControl"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [attr.data-uiid]="dataUiid + '-input'"
            [matAutocompleteDisabled]="disabled"
            (focusout)="clearInput()"
        />
    }

    <mat-autocomplete
        [class]="'autocomplete-panel ' + type"
        [attr.data-uiid]="dataUiid + '-autocomplete'"
        #auto="matAutocomplete"
        hideSingleSelectionIndicator
        (optionSelected)="onSelected($event)"
    >
        @for (option of filteredOptions | async; track option) {
            <mat-option
                [value]="option.id"
                [attr.data-uiid]="dataUiid + '-autocomplete-' + option.id"
                [class]="selectedOptions.indexOf(option) !== -1 ? 'mdc-list-item--selected' : ''"
                [class.archived]="option.isArchived || (useVisibility && !option.isVisible)"
            >
                {{ option.name }}</mat-option
            >
        }
    </mat-autocomplete>

    @if (!disabled) {
        <mat-icon matSuffix>expand_more</mat-icon>
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
